import React from 'react';
import { motion } from 'framer-motion';
import { HiExclamation, HiShieldCheck, HiCode, HiArrowRight, HiLightningBolt } from 'react-icons/hi';
import { Link } from 'react-router-dom';

const XboxExploitWidget = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="w-full"
    >
      <div className="glass-morphism-strong rounded-2xl p-4 sm:p-6 group cursor-pointer hover:shadow-lg transition-all duration-300">
        <Link to="/xbox-360/exploits/bad-update" className="block">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
            {/* Left side - Content */}
            <div className="flex-1 text-left">
              <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mb-3 space-y-2 sm:space-y-0">
                <motion.div 
                  whileHover={{ scale: 1.1, rotate: 5 }}
                  className="w-10 h-10 bg-accent-red/20 rounded-lg flex items-center justify-center self-start sm:self-center"
                >
                  <HiExclamation className="text-accent-red text-lg" />
                </motion.div>
                <div className="text-left">
                  <span className="font-jetbrains text-accent-red tracking-wider text-xs uppercase font-bold">
                    SECURITY RESEARCH
                  </span>
                  <div className="text-xs text-gray-400 mt-1">v1.2 Release</div>
                </div>
              </div>
              
              {/* Learn More Button - Mobile optimized positioning */}
              <motion.div 
                whileHover={{ scale: 1.1, x: 5 }}
                className="flex items-center space-x-2 text-accent-red group-hover:text-accent-red/80 transition-colors absolute top-4 right-4 sm:top-6 sm:right-6"
              >
                <span className="text-xs sm:text-sm font-medium hidden sm:inline">Learn More</span>
                <HiArrowRight className="text-lg group-hover:translate-x-1 transition-transform" />
              </motion.div>
              
              <h3 className="text-lg sm:text-xl font-space-grotesk font-bold text-white mb-2 group-hover:text-accent-red transition-colors text-left pr-16 sm:pr-20">
                THE WINCHESTER HAS BEEN DEFEATED
              </h3>
              
              <h4 className="text-base sm:text-lg font-space-grotesk font-semibold text-accent-red mb-3 text-left">
                Xbox 360 BadUpdate v1.2: From Exploit to Softmod
              </h4>
              
              <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 mb-3 text-left space-y-1 sm:space-y-0">
                <span className="text-gray-400 text-xs">Authors:</span>
                <div className="flex items-center space-x-3">
                  <span className="text-accent-blue text-xs font-medium">Ryan Miceli</span>
                  <span className="text-gray-500 hidden sm:inline">•</span>
                  <span className="text-accent-green text-xs font-medium">Amaan Dildar</span>
                </div>
              </div>
              
              <p className="text-gray-300 text-sm leading-relaxed mb-3 text-left">
                The software-only exploit for Xbox 360 has evolved beyond its research origins. 
                <span className="text-accent-red font-semibold"> v1.2 brings unprecedented stability</span>, 
                making it the first truly practical softmod solution for the platform.
              </p>
              
              {/* Stats - Mobile optimized layout */}
              <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-6 space-y-2 sm:space-y-0 text-xs text-left">
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center space-x-2"
                >
                  <HiShieldCheck className="text-accent-green flex-shrink-0" />
                  <span className="text-gray-400">80% Success Rate</span>
                </motion.div>
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center space-x-2"
                >
                  <HiLightningBolt className="text-accent-blue flex-shrink-0" />
                  <span className="text-gray-400">~15s Execution</span>
                </motion.div>
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  className="flex items-center space-x-2"
                >
                  <HiCode className="text-accent-purple flex-shrink-0" />
                  <span className="text-gray-400">Production Ready</span>
                </motion.div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </motion.div>
  );
};

export default XboxExploitWidget;
